import { VintageHalf } from "../types/generated/graphql";

export const getDatePart = (date: Date) => date.toISOString().split("T")[0];

export type VintageHalfQuarter = VintageHalf.Q1 | VintageHalf.Q2 | VintageHalf.Q3 | VintageHalf.Q4;
export const MONTHS_IN_QUARTER: Record<VintageHalfQuarter, string[]> = {
  [VintageHalf.Q1]: ["January", "February", "March"],
  [VintageHalf.Q2]: ["April", "May", "June"],
  [VintageHalf.Q3]: ["July", "August", "September"],
  [VintageHalf.Q4]: ["October", "November", "December"],
};
